import { render, staticRenderFns } from "./AkinSoft.vue?vue&type=template&id=0afb135e&scoped=true"
import script from "./AkinSoft.vue?vue&type=script&lang=js"
export * from "./AkinSoft.vue?vue&type=script&lang=js"
import style0 from "./AkinSoft.vue?vue&type=style&index=0&id=0afb135e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afb135e",
  null
  
)

export default component.exports